import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useWorkspace } from "../../context/WorkspaceRegionProvider";
import { WORKSPACE_CN, WORKSPACE_INTL } from "../../utils/workspace";

const WORKSPACE_DEEP_LINK_PATTERN = /^\/view\/(detail|register)(\/|$)/;

const WorkspaceDeepLinkGuard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { workspace } = useWorkspace();
  const prevWorkspaceRef = useRef(workspace);

  useEffect(() => {
    const prevWorkspace = prevWorkspaceRef.current;
    prevWorkspaceRef.current = workspace;

    if (
      prevWorkspace === WORKSPACE_INTL &&
      workspace === WORKSPACE_CN &&
      WORKSPACE_DEEP_LINK_PATTERN.test(location.pathname)
    ) {
      navigate("/view/home", { replace: true });
    }
  }, [workspace, location.pathname, navigate]);

  return null;
};

export default WorkspaceDeepLinkGuard;
